import React from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'

function PaginationV2({ clickForward, clickBackward, page, totalPage }) {

    return (
        <div className="flex justify-end items-center md:gap-[5px] gap-4 py-[15px]">
          <button
            onClick={clickBackward}
            disabled={page <= 1}
            className={`button-theme-pg p-0 md:w-[20px] md:h-[20px] w-[30px] h-[25px] rounded-l-full flex justify-center items-center ${
              page > 1 ? 'bg-[#FF9768] cursor-pointer' : 'bg-gray-300 cursor-not-allowed'
            }`}
          >
            <ChevronLeftIcon className="stroke-[#FFFFFF] w-4" />
          </button>
    
          <div className="text-[#3C423F] md:text-[12px] flex justify-between items-center gap-1">
            <div>{page}</div>
            <div>/</div>
            <div>{totalPage}</div>
          </div>
    
          <button
            onClick={clickForward}
            disabled={page >= totalPage}
            className={`button-theme-pg p-0 md:w-[20px] md:h-[20px] w-[30px] h-[25px] rounded-r-full flex justify-center items-center ${
              page < totalPage ? 'bg-[#FF9768] cursor-pointer' : 'bg-gray-300 cursor-not-allowed'
            }`}
          >
            <ChevronRightIcon className="stroke-[#FFFFFF] w-4" />
          </button>
        </div>
      );
    }

export default PaginationV2